/**
 * 05.1 E1–E2 · the prepayment S-curve and its monthly rate, the one definition (the prepay model, the Expander's twelve-month runoff
 * and the IRR base table read it; `@bsim/models` is out of reach of personas).
 *   05.1 E1  CPR = CPR_min + (CPR_max − CPR_min) ÷ (1 + e^−k(x − x_mid)),  x = rallyBp = (r^anchor − r^mtg) × 10,000
 *   05.1 E2  SMM = 1 − (1 − CPR)^(1/12)
 */
import type { Rate } from "./cp1_domain";

export interface PrepaySCurve { readonly midpointBp: number; readonly slopePerBp: number; readonly minCprRate: number; readonly maxCprRate: number }

/** 05.1 E1: the conditional prepayment rate at `rallyBp` (+ = rates fell below the vintage's anchor). */
export function sCurveCprRate(sCurve: PrepaySCurve, rallyBp: number): Rate {
  const { minCprRate, maxCprRate, slopePerBp, midpointBp } = sCurve;
  return (minCprRate + (maxCprRate - minCprRate) / (1 + Math.exp(-slopePerBp * (rallyBp - midpointBp)))) as Rate;
}

/** 05.1 E2: the single monthly mortality of an annual `cprRate`. */
export function smmOfCpr(cprRate: number): Rate {
  return -Math.expm1(Math.log1p(-cprRate) / 12) as Rate;
}
